<template>
  <li>
    <h2 class="h3">Bulk PDP Download</h2>
    <div class="row">
      <div class="col-lg-8">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label class="control-label">Program</label>
              <multiselect
                @input="handleSelectProgramCallback"
                :value="programSelected"
                :options="programs"
                track-by="id"
                label="name"
                v-validate="'required'"
                name="program"
                data-vv-validate-on="input|blur"
                :allow-empty="false"
                :searchable="true"
                :show-labels="false"
                :class="[errorClass('program'), validClass('program')]"
                placeholder/>

              <help-block field="program"/>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group">
              <label class="control-label">Placement</label>
              <multiselect
                v-model="params.placements"
                :options="placementOptions"
                track-by="id"
                label="number"
                name="placement"
                :multiple="true"
                :searchable="false"
                :show-labels="false"
                :show-no-results="true"
                placeholder="All Placements"/>

            </div><!-- /.form-group -->
          </div>

          <div class="col-lg-12">
            <div class="form-group">
              <label class="control-label">Agency</label>
              <multiselect
                v-model="params.agencies"
                :options="agencies"
                track-by="id"
                label="name"
                name="placement"
                :multiple="true"
                :searchable="false"
                :show-labels="false"
                :show-no-results="true"
                placeholder="All Agencies"/>
            </div><!-- /.form-group -->
          </div>

          <div class="col-lg-12">
            <div class="form-group">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  name="drafts"
                  class="custom-control-input custom-control-input-success"
                  value="1"
                  v-model="params.drafts"
                  id="draftsCheck"
                />
                <label
                  class="custom-control-label"
                  for="draftsCheck"
                >Include Incomplete PDP's?</label>
              </div>
            </div><!-- /.form-group -->
          </div>
        </div><!-- /.row -->
      </div>

      <div class="col-lg-4 text-right">
        <ladda-button :validate="true" :click="handleDownload" class="btn btn-info mt-lg-label">
          <font-awesome :icon="['far', 'file-archive']"/> Download Zip
        </ladda-button>
      </div>
    </div><!-- /.row -->
  </li>
</template>

<script>
import { programComputed, agencyComputed, agencyMethods } from 'vx/helpers'
import { map, snakeCase } from 'lodash'
import { http, handleServerErrors } from 'utils'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { saveAs } from 'file-saver'

export default {
  components: {
    Multiselect
  },

  data () {
    return {
      params: {
        program_id: null,
        placements: null,
        agencies: null,
        drafts: false
      },
      programSelected: null
    }
  },

  computed: {
    ...programComputed,
    ...agencyComputed,

    placementOptions () {
      let options = this.programSelected ? this.programSelected.placements : []

      return options
    }
  },

  async created () {
    await this.getAgencies()
  },

  methods: {
    ...agencyMethods,

    handleSelectProgramCallback (program) {
      this.programSelected = program

      this.params.program_id = program
        ? program.id
        : null

      this.params.placements = null
    },

    async handleDownload () {
      let params = {}

      if (this.params.placements !== null) {
        params.placement_ids = map(this.params.placements, 'id')
      }

      if (this.params.agencies !== null) {
        params.agency_ids = map(this.params.agencies, 'id')
      }

      if (this.params.drafts) {
        params.drafts = this.params.drafts ? 1 : 0
      }

      return http.get(`/reports/bulk-pdp/${this.params.program_id}`, { responseType: 'blob', params }).then(response => {
        if (response.status === 204) {
          this.$noty.warning('There are no PDP\'s to Download')
          return
        }

        const now = moment().format('YYYY_MM_DD')
        const filename = `${snakeCase(this.programSelected.name)}_pdp_completion_status_report_${now}.zip`

        saveAs(response.data, filename)
      }).catch(error => {
        handleServerErrors(error, this.$validator)
      })
    }
  }
}
</script>

<style>
</style>
